import React from 'react';
import PropTypes from 'prop-types';
import Form from '../../../../antd/form/Form/Form';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField';
import { t } from '../../../../../i18n';
import { required } from '../../../../antd/form/FormValidation';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import FormButton from '../../../../antd/form/FormButton/FormButton';
import { CollapseBlock } from '../../../../common';

export function UnitsForm({ initials, onSubmit }) {
  return (
    <Form initialValues={initials} onFinish={onSubmit}>
      <CollapseBlock title={t('Obsah')} collapsible>
        <FormTextField
          label={t('Jednotka')}
          name={'unit'}
          rules={[required(t)]}
        />
      </CollapseBlock>
      <FormButtonsContainer>
        <FormButton submitOnClick={true}>{t('Uložiť')}</FormButton>
      </FormButtonsContainer>
    </Form>
  );
}

UnitsForm.propTypes = {
  initials: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
};
